module.exports = __webpack_public_path__ + "img/icon-calendar-heart.74154bf3.svg";